<script>
import { Message } from "element-ui";

export default {
  name: "WHThirdMenu",
  data() {
    return {
      show: false,
      left: 0,
      width: 0,
      menus: [],
      clear_width_time: null,
    };
  },
  methods: {
    showMenu(left, width, menus = []) {
      if (this.clear_width_time) clearTimeout(this.clear_width_time);
      this.left = left + width + "px";
      this.width = width + "px";
      this.menus = menus;
      this.show = true;
    },
    hideMenu() {
      this.show = false;
      this.clearWidth();
    },
    selfShow() {
      if (this.clear_width_time) clearTimeout(this.clear_width_time);
      this.show = true;
    },
    setHide() {
      this.show = false;
      this.menus = [];
      this.clearWidth();
    },
    clearWidth() {
      this.clear_width_time = setTimeout(() => (this.width = 0), 10);
    },
    handleMenuItem(menu) {
      if (!menu.path) return Message.info("该菜单没有路径");
      this.$router.push(menu.path);
      this.$emit("hideWHMM");
    },
  },
};
</script>

<template>
  <div
    class="website-third-menu"
    @mouseenter.stop.prevent="selfShow"
    @mouseleave.stop.prevent="setHide"
    :class="{
      show: show,
    }"
    :style="{
      left,
      width,
    }"
  >
    <div
      class="third-menu-item"
      @click.stop="handleMenuItem(item)"
      v-for="(item, index) in menus"
      :key="index"
    >
      {{ item.title }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.website-third-menu {
  position: absolute;
  top: 1px;
  width: 0;
  height: 0;
  overflow: hidden;
  background-color: #F7EEEF;
  transition: width 0.1s ease-in-out;
  z-index: 2003;

  &.show {
    height: 100%;
  }

  .third-menu-item {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 16px;
    height: var(--app-header-menu-item-height);
    line-height: var(--app-header-menu-item-height);
    cursor: pointer;
    text-align: center;
    user-select: none;

    &:hover {
      color: #D4062E;
      background-color: #fcdbdb;
    }
  }
}
</style>
